import { render, staticRenderFns } from "./ContactEditPriceRules.vue?vue&type=template&id=0fc73d4c"
import script from "./ContactEditPriceRules.vue?vue&type=script&lang=ts"
export * from "./ContactEditPriceRules.vue?vue&type=script&lang=ts"
import style0 from "./ContactEditPriceRules.vue?vue&type=style&index=0&id=0fc73d4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports